import styled from 'styled-components';

export const StyledLoginContainer = styled.div`
  margin: 20px auto;
  width: 100%;
  height: 100%;
  button {
    width: 100%;
    margin: 20px auto;
  }
  hr {
    line-height: 1em;
    position: relative;
    background-color: #ffffff;
    outline: 0;
    border: 0;
    color: black;
    text-align: center;
    height: 1.5em;
    &:before {
      content: '';
      // use the linear-gradient for the fading effect
      // use a solid background color for a solid bar
      background: linear-gradient(to right, transparent, #818078, transparent);
      position: absolute;
      left: 0;
      top: 50%;
      width: 100%;
      height: 1px;
    }
    &:after {
      content: attr(data-content);
      position: relative;
      display: inline-block;
      color: black;

      padding: 0 0.5em;
      line-height: 1.5em;
      // this is really the only tricky part, you need to specify the background color of the container element...
      color: #818078;
      background-color: #fcfcfa;
    }
  }
  .backdrop {
    z-index: 999;
    background-color: rgba(255, 255, 255, 0.8);
  }
`;
